import "./components/accessibility.js";
import "./components/back-to-top.js";
import "./components/carousels.js";
import "./components/cookie-consent.js";
import "./components/cover-videos.js";
import "./components/fixed-button.js";
import "./components/lightboxes.js";
import "./components/mobile-menu.js";
import "./components/notification-bar.js";
import "./components/search-overlay.js";
import "./components/trays.js";

document.addEventListener("DOMContentLoaded", function () {
	if (true === window.bds_theme.debug.enabled) {
		console.log(bds_theme);
	}
	const grid = document.querySelector(
		".wp-block-post-template.is-style-masonry:has(li.type-project)",
	);
	if (!grid) return;

	// Start grid invisible
	grid.classList.add("grid-fade");
	grid.classList.remove("grid-visible");

	const posts = Array.from(
		grid.querySelectorAll(".wp-block-post.type-project"),
	);
	const categoryLinks = document.querySelectorAll(
		".cat-item a, .wp-block-categories-list a",
	);

	// Helper: Apply or remove masonry based on screen size
	function updateMasonryLayout() {
		if (window.innerWidth > 782) {
			reflowMasonry();
		} else {
			// Remove masonry flex styles for all posts
			Array.from(grid.children).forEach((item) => {
				item.style.flex = "";
			});
		}
	}

	// Run masonry reflow if appropriate
	updateMasonryLayout();

	// Fade in grid after a short delay
	setTimeout(() => {
		grid.classList.remove("grid-fade");
		grid.classList.add("grid-visible");
	}, 50);

	// Masonry reflow function for .masonry grids
	function reflowMasonry() {
		const masonryGrid = document.querySelector(
			".wp-block-post-template.is-style-masonry:has(li.type-project)",
		);
		if (!masonryGrid) return;
		const visibleItems = Array.from(masonryGrid.children).filter(
			(item) =>
				!item.classList.contains("hidden") &&
				item.style.display !== "none",
		);

		visibleItems.forEach((item, i) => {
			item.style.flex = ""; // Reset
			if (i % 5 === 0 || i % 5 === 2) {
				item.style.flex =
					"1 1 calc(31% - (var(--wp--preset--spacing--20) / 3))";
			} else if (i % 5 === 1) {
				item.style.flex =
					"1 1 calc(37% - (var(--wp--preset--spacing--20) / 3))";
			} else if (i % 5 === 3) {
				item.style.flex =
					"1 1 calc(72% - (var(--wp--preset--spacing--20) / 2))";
			} else if (i % 5 === 4) {
				item.style.flex =
					"1 1 calc(28% - (var(--wp--preset--spacing--20) / 2))";
			}
		});

		// Clear flex from hidden items
		Array.from(masonryGrid.children).forEach((item) => {
			if (
				item.classList.contains("hidden") ||
				item.style.display === "none"
			) {
				item.style.flex = "";
			}
		});
	}

	function fadeGridOutIn(callback) {
		grid.classList.remove("grid-visible");
		grid.classList.add("grid-fade");

		setTimeout(() => {
			callback();
			updateMasonryLayout();
			// Fade in after reflow
			grid.classList.remove("grid-fade");
			grid.classList.add("grid-visible");
		}, 400); // Match transition duration
	}

	function showAllPosts() {
		fadeGridOutIn(() => {
			posts.forEach((post) => {
				post.style.display = "";
				post.classList.remove("hidden");
			});
		});
	}

	function filterPostsByCategory(categorySlug) {
		fadeGridOutIn(() => {
			posts.forEach((post) => {
				const match = post.classList.contains(
					"project_category-" + categorySlug,
				);
				if (match) {
					post.style.display = "";
					post.classList.remove("hidden");
				} else {
					post.style.display = "none";
					post.classList.add("hidden");
				}
			});
		});
	}

	categoryLinks.forEach((link) => {
		link.addEventListener("click", function (event) {
			event.preventDefault();

			// Extract slug from the URL
			const url = link.getAttribute("href").replace(/\/+$/, "");
			const slug = url.split("/").pop().toLowerCase();

			// Handle "All" or "Projects" links
			if (slug === "projects" || slug === "all") {
				showAllPosts();
				window.history.pushState({}, "", window.location.pathname);
			} else {
				filterPostsByCategory(slug);
				window.history.pushState(
					{ project_category: slug },
					"",
					"?project_category=" + encodeURIComponent(slug),
				);
			}
		});
	});

	// On page load, filter by URL param if present
	const params = new URLSearchParams(window.location.search);
	const filterCategory = params.get("project_category");

	if (filterCategory) {
		filterPostsByCategory(filterCategory);
	} else {
		showAllPosts();
	}

	// Listen for window resize to update masonry layout
	window.addEventListener("resize", updateMasonryLayout);
});
